import {isArray} from '@apollo/client/cache/inmemory/helpers';
import {PibisiFlag} from 'api/generated';
import {AnchorLink, PropertyList} from 'components';
import {StatusTag} from 'components/StatusTag';
import humanize from 'humanize-string';
import {colors} from 'lib/colors';
import React from 'react';
import {FlagContent} from 'routes/Account/Pibisi/FlagContent';
import {PibisiStatusTag} from 'routes/Account/Pibisi/PibisiStatusTag';
import {config} from 'stage.config';
import {PibisiMatch} from './types';

type Props = {
  match: PibisiMatch | null;
};

export const Match: React.FC<Props> = ({match}) => {
  if (!match) return null;
  const type = Object.keys(match).find((key) => isArray(match[key as keyof PibisiMatch]));
  const flags = Object.entries(match)
    .filter(([, value]) => isArray(value))
    .map(([, value]) => value)
    .flat() as Array<PibisiFlag>;

  return (
    <>
      <PropertyList
        omitEmpty
        properties={[
          {
            label: 'Match ID',
            copyable: {text: match.id},
            value: (
              <AnchorLink
                href={`https://pibisi.com/es/a/${config.pibisiAccountId}/matches/${match.id}`}
                target="_blank">
                {match.id}
              </AnchorLink>
            )
          },
          {
            label: 'Legal type',
            value: match.legalType
          },
          {
            label: 'Legal name',
            value: match.legalName
          },
          {
            label: 'Match Type',
            value: <StatusTag color={colors.error}>{humanize(type || '')}</StatusTag>
          },
          {
            label: 'Match Status',
            value: <PibisiStatusTag status={match.status} />
          }
        ]}
      />
      {flags.map((flag) => (
        <FlagContent content={flag.content} />
      ))}
    </>
  );
};
